export enum EmailTargetType {
  ALL_ORG_USERS = "all_org_users",
  ALL_FACILITY_USERS = "all_facility_users",
  SPECIFIC_ORG_USERS = "specific_org_users",
  FACILITY_USERS_OF_ORGS = "facility_users_of_orgs",
  SPECIFIC_FACILITY_USERS = "specific_facility_users"
}

export interface MassEmailPayload {
  subject: string;
  text: string;
  replyToEmail: string;
  bccToEmail: string;
  targetType: EmailTargetType;
  organizationIds?: number[];
  locationIds?: number[];
}
